import { createContext, useContext } from 'react';

type SalesBattlecardContextType = {
  selectedCompetitorId: number | null;
};

export const SalesBattlecardContext = createContext<SalesBattlecardContextType>({
  selectedCompetitorId: null,
});

export const useSalesBattlecardContext = () => useContext(SalesBattlecardContext);
